export default __webpack_public_path__ + "static/media/EM0700.34I-41832_-25095_0.b83ec014.jpg";